import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304011Status: 'idle',
    startProcess304011Error: undefined as any,
    loadUserParamsProcess304011Status: 'idle',
    loadUserParamsProcess304011Error: undefined as any,

    process304011List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304011 = createAsyncThunk('process304011Slice/startProcess304011', async ({ process304011 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304011/`,
        prepareData(process304011),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304011Status } = getState().process304011Slice
        return startProcess304011Status !== 'pending'
    }
})

export const loadUserParamsProcess304011 = createAsyncThunk('process304011Slice/loadUserParamsProcess304011', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304011/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304011Status } = getState().process304011Slice
        return loadUserParamsProcess304011Status !== 'pending'
    }
})

const Process304011Slice = createSlice({
    name: 'process304011Slice',
    initialState,
    reducers: {
        resetstartProcess304011: (state) => {
            state.job = undefined
            state.startProcess304011Error = undefined
        },
        resetstartProcess304011Error: (state) => {
            state.startProcess304011Error = undefined
        },
        resetloadUserParamsProcess304011: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304011Error = undefined
        },
        resetloadUserParamsProcess304011Error: (state) => {
            state.loadUserParamsProcess304011Error = undefined
        },
        removeFromProcess304011ListById: (state, action) => {
            state.process304011List = state.process304011List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304011ListByIds: (state, action) => {
            state.process304011List = state.process304011List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304011List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304011Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304011List = []
            state.startProcess304011Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304011.pending, (state) => {
            state.startProcess304011Status = 'pending'
            state.startProcess304011Error = undefined
        })
        builder.addCase(startProcess304011.fulfilled, (state, action) => {
            state.startProcess304011Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304011.rejected, (state, action) => {
            state.startProcess304011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304011Error = action.error.message
            } else {
                state.startProcess304011Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304011.pending, (state) => {
            state.loadUserParamsProcess304011Status = 'pending'
            state.loadUserParamsProcess304011Error = undefined
        })
        builder.addCase(loadUserParamsProcess304011.fulfilled, (state, action) => {
            state.loadUserParamsProcess304011Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304011.rejected, (state, action) => {
            state.loadUserParamsProcess304011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304011Error = action.error.message
            } else {
                state.loadUserParamsProcess304011Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304011,
    resetstartProcess304011Error,
    resetloadUserParamsProcess304011,
    resetloadUserParamsProcess304011Error,
    removeFromProcess304011ListById,
    removeFromProcess304011ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304011Slice.actions
export default Process304011Slice.reducer
